import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  getCrsReportOffices,
  getCrsReportOfficesClear,
} from "../../../redux/reports/actions";
import { SessionKeys } from "../../../utils/AppUtils";
import _ from "lodash";
import CONFIG from "../../../utils/config";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import NotFoundImage from "../../NewDesign/NotFound/NotFoundImage";

const OfficesReportSection = (props) => {

  const { mesg, isMobile,
    check, overAllOfficesData, setOverAllOfficesData,
    setCountForOffice, counterForOffice, setCounterForOffice,
    totalOffices, cmpletionText, isLP, courseOrVideo, selectedFilters } = props

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lpOfficesRes = useSelector((state) => state?.report?.lpOffices);
  const crsOfficesRes = useSelector((state) => state.report?.crsReportOffices);
  const authBroker = useSelector((state) => state.auth.authBroker)
  const authIframeBroker = useSelector(state => state.auth.authIframeBroker)

  const [loadSpinner, setLoadSpinner] = useState(true)
  const [officeLabel, setOfficeLabel] = useState('')

  useEffect(() => {
		if (!_.isEmpty(authBroker)) {
			if (!_.isEmpty(authBroker.payload?.user?.config) && authBroker.payload?.user?.config.office_name) {
				setOfficeLabel(authBroker.payload?.user?.config.office_name)
			} else {
				setOfficeLabel('Offices')
			}
		}
	}, [authBroker])

  useEffect(() => {
		if (!_.isEmpty(authIframeBroker)) {
      // alert(JSON.stringify(authIframeBroker.payload.user.config))
			if (!_.isEmpty(authIframeBroker.payload?.user?.config) && authIframeBroker.payload?.user?.config.office_name) {
				setOfficeLabel(authIframeBroker.payload?.user?.config.office_name)
			} else {
				setOfficeLabel('Offices')
			}
		}
	}, [authIframeBroker])


  //LP Offices
  useEffect(() => {
    setOverAllOfficesData([])
    return (() => {
      dispatch(getCrsReportOfficesClear())
    })
  }, [])

  useEffect(() => {
    if (!_.isEmpty(crsOfficesRes) || !_.isEmpty(lpOfficesRes)) {
      setLoadSpinner(false)
      // if (crsOfficesRes?.status === "success") {
      //   let allData = (crsOfficesRes?.payload?.payload?.offices);
      //   setTotalOffices(crsOfficesRes?.payload?.payload)
      //   let temparr = _.cloneDeep(overAllOfficesData)
      //   if (counter === 1) {
      //     temparr = []
      //   }
      //   setOverAllOfficesData([...temparr, ...allData])
      //   getCrsReportOfficesClear()
      // }
    }
  }, [crsOfficesRes, lpOfficesRes])
  return (
    <section className="offices-rpeort progress-box-report">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="progess-count-tiel">
              {officeLabel}&nbsp;<strong>({totalOffices?.total_offices})</strong>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          {(overAllOfficesData !== undefined) && (overAllOfficesData !== "") && (!_.isEmpty(overAllOfficesData)) ? overAllOfficesData?.map((i, index) => {
            return (
              <>
                <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-report" key={index}>
                  <div className="reopor-box-progess">
                    <div className="progess-profile d-flex">
                      <div className="userprogress-details">
                        <h5 className="user-tiele">{i?.office_name}</h5>
                        <OverlayTrigger
                          key='bottom'
                          placement='bottom'
                          overlay={
                            <Tooltip id={`tooltip-bottom`}>
                              <div
                                style={{
                                  color: "white",
                                  backgroundColor: "black",
                                }}

                              >{i?.office_city},{i?.office_province}</div>
                            </Tooltip>
                          }
                        >
                          <p >{i?.office_city},{i?.office_province}</p>
                        </OverlayTrigger>
                      </div>
                    </div>
                    <hr />

                    <div class="progress-details">
                      <div class="progess-report-graph">
                        <div class="circlebox">
                          <div
                            className="circularProgress-sm"
                            style={{
                              width: 72,
                              height: 72,
                              position: "relative",
                            }}
                          >
                            <CircularProgressbar
                              value={i?.percentage}
                              strokeWidth={8}
                              styles={buildStyles({
                                pathColor: "#6941C6", //FF9700=yellow
                                trailColor: "#EBEBEB",
                              })
                              }
                            />
                            <div className="centerprogess-con"
                              style={{
                                position: "absolute",
                                top: "1.2rem",
                                width: "72px",
                                textAlign: "center",
                              }}
                            >
                              {true ? (
                                <>
                                  <strong
                                    style={{ color: "#6941C6" }}
                                  >{`${i?.percentage}%`}</strong>
                                  <small>Progress</small>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="progess-count-show-new">
                        <div class="learning-points-new">
                          <strong>{i?.total_completed}/</strong>{i?.total_assigned}
                        </div>
                        <div class="learning-points-name">
                          {cmpletionText}
                        </div>
                      </div>

                    </div>
                    <div className="prog-link" onClick={() => {
                        localStorage.setItem('SELECTED_FILTER', JSON.stringify({
                          isLP: (window.location.pathname.includes('/lp-report') || isLP),
                          selectedFilters
                        }))
                      if (window.location.pathname.includes('/lp-report') || isLP) {
                        let url = isMobile ? "/lp-report-office-mobile-detail" : "/lp-report-office-detail";
                        url = url + "?id=" + i.office_id + "&isCompliance=" + (check ? 1 : 0);
                        navigate(url)

                      } else {
                        let url = isMobile ? '/compliance-report-detail-mobile' : '/compliance-report-detail';
                        url = url + '?id=' + i.office_id + "&isCompliance=" + (check ? 1 : 0);
                        if(courseOrVideo)
                        {
                          url = url + "&isVideos=true";
                        } 
                        else
                        {
                          url = url + "&isVideos=false";
                        }
                        navigate(url)
                      }
                    }}>
                      View More
                    </div>
                  </div>
                </div>
              </>
            );
          })
            :
            <div className="col-md-12">
              <div className="not-found mt-3">
                <div className="interboxes">
                  {/* <img src="/images/telescope.svg" alt="Not Found" /> */}
                  <NotFoundImage />
                  <p> {mesg}</p>
                </div>
              </div>
            </div>
          }
          <div className="col-md-12 mt-3">
            <p className="text-center">
              {overAllOfficesData?.length === 0 || (totalOffices?.total_offices === overAllOfficesData?.length) ? "" : (totalOffices?.total_offices < 4) ? "" :
                <button
                  type="button"
                  id="number"
                  className="btn btn-primary-complete"
                  onClick={() => {
                    setCountForOffice(counterForOffice, setCounterForOffice);
                    setLoadSpinner(true);
                  }
                  }
                >
                  {(loadSpinner) ?
                    <div className="d-flex justify-content-center w-100">
                      <Spinner animation="border" />
                    </div>
                    : "Load More"}
                </button>
              }
            </p>
          </div>
        </div>
      </div>
    </section>
  )
};

export default OfficesReportSection;
